import React from 'react';
import CapabilityPageSummary from './CapabilityPageSummary';
import StandardPageSummary from './StandardPageSummary';
import UnknownPageSummary from './UnknownPageSummary';

function PageSummary({ ...props }) {
  switch (props.page.type) {
    case 'standard-questions':
      return <StandardPageSummary {...props} />;
    case 'capability-questions':
      return <CapabilityPageSummary {...props} />;
    default:
      return <UnknownPageSummary {...props} />;
  }
}

export default PageSummary;
